module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "lumi-gradient-button",
    on: {
      "click": _vm.click
    }
  }, [_c('div', {
    staticClass: "lumi-backgroundfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "lumi-borderfix-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "lumi-button-text"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "lumi-borderfix-right"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-075a39d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/LumiGradientButton.vue
// module id = 57
// module chunks = 0